// extracted by mini-css-extract-plugin
module.exports = {"textAsLink":"styles_textAsLink__22Hh0"};